import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleKeydown = this.onPhoneKeydown.bind(this)
    this.handleInput = this.onPhoneInput.bind(this)
    this.handlePaste = this.onPhonePaste.bind(this)

    this.formatCurrentValue()
    this.element.addEventListener("keydown", this.handleKeydown)
    this.element.addEventListener("input", this.handleInput)
    this.element.addEventListener("paste", this.handlePaste)
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.handleKeydown)
    this.element.removeEventListener("input", this.handleInput)
    this.element.removeEventListener("paste", this.handlePaste)
  }

  onPhonePaste(event) {
    const inputNumbersValue = this.inputNumbersValue
    const pasted = event.clipboardData || window.clipboardData

    if (!pasted) return

    const pastedText = pasted.getData("Text")
    if (/\D/g.test(pastedText)) this.element.value = inputNumbersValue
  }

  onPhoneInput(event) {
    let inputNumbersValue = this.inputNumbersValue
    const selectionStart = this.element.selectionStart

    if (!inputNumbersValue) {
      this.element.value = ""
      return
    }

    if (this.element.value.length !== selectionStart) {
      if (event.data && /\D/g.test(event.data)) this.element.value = inputNumbersValue
      return
    }

    this.element.value = this.formatPhone(inputNumbersValue)
  }

  onPhoneKeydown(event) {
    if (event.key !== "Backspace") return
    if (this.inputNumbersValue.length === 1) this.element.value = ""
  }

  get inputNumbersValue() {
    return this.element.value.replace(/\D/g, "")
  }

  formatCurrentValue() {
    if (!this.inputNumbersValue) return

    this.element.value = this.formatPhone(this.inputNumbersValue)
  }

  formatPhone(inputNumbersValue) {
    let normalizedNumbersValue = inputNumbersValue

    if (["7", "8", "9"].includes(normalizedNumbersValue[0])) {
      if (normalizedNumbersValue[0] === "9") normalizedNumbersValue = `7${normalizedNumbersValue}`

      let formattedInputValue = "+7 "
      if (normalizedNumbersValue.length > 1) {
        formattedInputValue += `(${normalizedNumbersValue.substring(1, 4)}`
      }
      if (normalizedNumbersValue.length >= 5) {
        formattedInputValue += `) ${normalizedNumbersValue.substring(4, 7)}`
      }
      if (normalizedNumbersValue.length >= 8) {
        formattedInputValue += `-${normalizedNumbersValue.substring(7, 9)}`
      }
      if (normalizedNumbersValue.length >= 10) {
        formattedInputValue += `-${normalizedNumbersValue.substring(9, 11)}`
      }

      return formattedInputValue
    }

    return `+${normalizedNumbersValue.substring(0, 16)}`
  }
}
